import {createSlice} from '@reduxjs/toolkit';
//types
import {IOrganizationReducer} from '../../utils/types';
//actions
import {
	organizationSignup,
	organizationGoogleSignup,
	organizationAppleSignup,
	organizationLogin,
	organizationLogout,
	getOrganizationInfo,
	changeProfile,
	getTeamMemberInfo,
} from './actions';
//operations
import {
	getOrganizationInfoOperation,
	getTeamMemberInfoOperation,
	organizationLoginOperation,
	organizationLogoutOperation,
	organizationSignupOperation,
	pendingOperation,
	rejectedOperation,
	updateOrganizationInfoOperation,
} from './operations';

export const initialState: IOrganizationReducer = {
	organization: null,
	team: null,
	isLoading: false,
};

const organizationStore = createSlice({
	name: 'organization',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(organizationSignup.pending, pendingOperation);
		builder.addCase(organizationSignup.fulfilled, organizationSignupOperation);
		builder.addCase(organizationSignup.rejected, rejectedOperation);

		builder.addCase(organizationGoogleSignup.pending, pendingOperation);
		builder.addCase(organizationGoogleSignup.fulfilled, organizationSignupOperation);
		builder.addCase(organizationGoogleSignup.rejected, rejectedOperation);

		builder.addCase(organizationAppleSignup.pending, pendingOperation);
		builder.addCase(organizationAppleSignup.fulfilled, organizationSignupOperation);
		builder.addCase(organizationAppleSignup.rejected, rejectedOperation);

		builder.addCase(organizationLogin.pending, pendingOperation);
		builder.addCase(organizationLogin.fulfilled, organizationLoginOperation);
		builder.addCase(organizationLogin.rejected, rejectedOperation);

		builder.addCase(organizationLogout.pending, pendingOperation);
		builder.addCase(organizationLogout.fulfilled, organizationLogoutOperation);
		builder.addCase(organizationLogout.rejected, rejectedOperation);

		builder.addCase(getOrganizationInfo.pending, pendingOperation);
		builder.addCase(getOrganizationInfo.fulfilled, getOrganizationInfoOperation);
		builder.addCase(getOrganizationInfo.rejected, rejectedOperation);

		builder.addCase(changeProfile.pending, pendingOperation);
		builder.addCase(changeProfile.fulfilled, updateOrganizationInfoOperation);
		builder.addCase(changeProfile.rejected, rejectedOperation);

		builder.addCase(getTeamMemberInfo.pending, pendingOperation);
		builder.addCase(getTeamMemberInfo.fulfilled, getTeamMemberInfoOperation);
		builder.addCase(getTeamMemberInfo.rejected, rejectedOperation);
	},
});

export default organizationStore.reducer;
